import React from "react";
import { useTranslation } from "react-i18next";
import SubHeader from "../../components/common/SubHeader";
import { useParams } from "react-router-dom";
import { GET, PUT } from "../../utils/HttpClient";
import { URL_POST_BAKING } from "../../constance/urls";
import ErrorMessage from "../../components/common/ErrorMessage";
import { defaultPostBakingWasteWoodCountDetail } from "../../constance/dataTypes";
import * as _ from "lodash";
import { Toast } from "../../utils/Toast";
import { isDateValid } from "../../utils/stringFormat";
import { useHistory } from "react-router-dom";
import OvenForm from "../../components/oven/OvenForm";
import PostBakingWasteWoodCountList from "../../components/post-baking-waste-wood-count/PostBakingWasteWoodCountList";
import WasteWoodCountModal from "../../components/post-baking-waste-wood-count/WasteWoodCountModal";
import { Form, Layout, Spin, Input, DatePicker, Button, Space, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { HUMAN_DATE_FORMAT, DATE_FORMAT } from "../../constance/strings";
import { PlusOutlined, SaveFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import ColorButton from "../../components/common/ColorButton";
import { GREEN } from "../../constance/color";


export default function PostBakingWasteWoodCountDetailView() {

  const history = useHistory();
  const { t } = useTranslation();
  const { id } = useParams();
  const [form] = Form.useForm();

  const ovenFormRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [inputTarget, setInputTarget] = React.useState(null);
  const [editable, setEditable] = React.useState(false);

  const fetchData = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT}${id}/`)
      const data = response.data;
      form.setFieldsValue({
        ...data,
        ovens: data.ovens,
        post_baking_group_date: data.post_baking_group_date ? dayjs(data.post_baking_group_date) : null,
        created: data.created ? new Date(data.created).toLocaleDateString('en-GB') : null,
      });

      setEditable(!data.interfaced);
      if (ovenFormRef.current) {
        ovenFormRef.current.initial(data.ovens || [])
      }

    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  const handleSubmit = async (values) => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const validate = await form.validateFields();

      const requestData = {
        ...values,
        ovens: values.ovens || [],
        post_baking_group_date: values.post_baking_group_date?.format(DATE_FORMAT),
      };
      const response = await GET(URL_POST_BAKING.CHECK_POST_BAKING_GROUP,
        {
          date: requestData.post_baking_group_date,
          ovens: Array.isArray(requestData.ovens) ? requestData.ovens.join(',') : requestData.ovens,
        })
      if (!response.data.exists) {
        Toast.error(t('error'))
        setErrorMessages(t('post_baking_waste_wood_count.errors.no_wood'))
        return;
      }
      await PUT(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT}${id}/`, requestData)
      fetchData();
      Toast.success(t('succes'))
    } catch (error) {
      Toast.error(t('error'))
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id])

  return (
    <div>
      <Layout>
        <SubHeader />
        <Content style={{ margin: '24px' }}>
          <Title level={2}>{t('post_baking_waste_wood_count.detail')}</Title>
          <ErrorMessage message={errorMessages} length={100} />
          <Spin spinning={loading} tip={t('loading')} fullscreen />
          <Form form={form} initialValues={defaultPostBakingWasteWoodCountDetail} >
            <Row justify={'center'} >
              <Form.Item name={'id'} hidden />
              <Form.Item
                label={t('post_baking_waste_wood_count.count_date')}
                name={'created'}>
                <Input variant="borderless" readOnly />
              </Form.Item>
            </Row>
            <Row justify={'center'} style={{ width: '100%' }}>
              <Form.Item
                label={t('post_baking_waste_wood_count.group_date')}
                name={'post_baking_group_date'}
                rules={[{ required: true, message: t('error_messages.validation.required') }]}>
                <DatePicker
                  placeholder={t('post_baking_waste_wood_count.group_date')}
                  format={HUMAN_DATE_FORMAT}
                  inputReadOnly={!editable}
                  open={editable ? undefined : false}
                  allowClear={editable ? undefined : false} />
              </Form.Item>
            </Row>

            <OvenForm
              ref={ovenFormRef}
              form={form}
              readOnly={!editable}
              setUrl={URL_POST_BAKING.OVEN_SET}
              params={{ date: form.getFieldValue('post_baking_group_date') || null }} />

            <PostBakingWasteWoodCountList
              dataList={form.getFieldValue('wood_size_amount_map_list') || []}
              readOnly={!editable}
              onEdit={setInputTarget}
              fetchData={fetchData} />

            <Space direction="vertical" size={'large'}>
              {editable &&
                <ColorButton
                  variant="outlined"
                  color='primary'
                  override={GREEN}
                  icon={<PlusOutlined />}
                  onClick={() => setInputTarget('add')} >{t('add')}</ColorButton>
              }
              <Space>
                {editable &&
                  <Button
                    type="primary"
                    icon={<SaveFilled />}
                    loading={loading}
                    onClick={() => handleSubmit(form.getFieldsValue())} >{t('save')}</Button>
                }
                <Button
                  variant="filled"
                  color="default"
                  loading={loading}
                  onClick={() => history.goBack()}>{t('back')}</Button>
              </Space>
            </Space>

          </Form>

          <WasteWoodCountModal
            transaction={form.getFieldsValue()}
            open={inputTarget != null}
            onClose={() => {
              setInputTarget(null);
              fetchData();
            }}
            target={inputTarget} />

        </Content>
      </Layout>
    </div>
  )
}